import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useChangePasswordSchema = () => {
  const { t } = useTranslate()

  const validationRules = {
    minLength: 8,
    lowercase: /[a-z]/,
    uppercase: /[A-Z]/,
    number: /[0-9]/,
  }

  const changePasswordSchema = z
    .object({
      password: z
        .string()
        .min(validationRules.minLength, t('common_validation_minLength'))
        .regex(validationRules.lowercase, t('common_validation_lowercase'))
        .regex(validationRules.uppercase, t('common_validation_uppercase'))
        .regex(validationRules.number, t('common_validation_number')),
      confirmPassword: z.string({
        message: t('common_validation_confirmPassword_required'),
      }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('common_validation_match'),
      path: ['confirmPassword'],
    })

  return {
    changePasswordSchema,
    validationRules,
  }
}
